import { SocketConnectionInfoState } from './sockets.interfaces';

export const socketsInitialState: SocketConnectionInfoState = {
  socketConnectionInfos: []
};
